import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a90d515e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "F3DScaleAItemContainer items-center w-fit relative"
};
const _hoisted_2 = {
  class: "w-11 h-6 text-center"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "flex gap-1 w-11 justify-center h-4"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb1.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/cb1.svg",
  class: "w-4 ptr"
}, null, -1));
const _hoisted_14 = {
  key: 0,
  class: "flex gap-1 w-11 justify-center h-4"
};
const _hoisted_15 = {
  key: 1,
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/circle.svg",
  class: "w-2 absolute top-6 left-1"
};
const _hoisted_16 = {
  key: 2,
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/star.svg",
  class: "w-2 absolute top-6 left-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.showIdx ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(Math.abs($props.idx) + 1), 1)) : _createCommentVNode("", true)]), _createElementVNode("img", {
    src: `https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/${$props.imgIdx}.svg`,
    class: "w-11"
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [$props.answerMode ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("img", {
    src: `https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/${$data.chooseSide == 1 ? 'cb1' : 'cb'}.svg`,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onLeftClick && $options.onLeftClick(...args)),
    class: "w-4 ptr"
  }, null, 8, _hoisted_6), _createElementVNode("img", {
    src: `https://sjxzc.oss-cn-beijing.aliyuncs.com/8s8sf3dlb/${$data.chooseSide == 2 ? 'cb1' : 'cb'}.svg`,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onRightClick && $options.onRightClick(...args)),
    class: "w-4 ptr"
  }, null, 8, _hoisted_7)], 64)) : $props.showBox && $props.choosed == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_8, _hoisted_9], 64)) : $props.showBox && $props.choosed == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_10, _hoisted_11], 64)) : $props.showBox && $props.choosed == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_hoisted_12, _hoisted_13], 64)) : _createCommentVNode("", true)]), !$props.answerMode && $props.showBox ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($options.getJudgment()), 1)) : _createCommentVNode("", true), $props.flag == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true), $props.flag == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : _createCommentVNode("", true)]);
}